const setLoading = (bool) => {
  return {
    type: "loading",
    bool,
  };
};

export default setLoading;
